// RequestFormMain.jsx
import React, { useEffect, useState } from "react";
import Header from "./Components/RequsetHeader/header";
import RegistrationFormNew from "./Components/RequestForm/RegistrationFormNew";
import { useNavigate } from "react-router-dom";
import Modal from "react-modal";
import { saveAs } from "file-saver";
import { baseUrl } from "../../Constnats/constants";
import warningIcon  from "../LandingPage/img/warning_icon.svg";
import dwnloadWhite  from "../LandingPage/img/dwnloadWhite.svg";
// Set the app element for accessibility with react-modal
Modal.setAppElement('#root');

function RequestFormMain() {
  const navigate = useNavigate();

  const handleClose = () => {
    navigate("/");
  };

  const [selectedFile, setSelectedFile] = useState(null);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [termsModalOpen, setTermsModalOpen] = useState(false);
  const [downloadFileModal, setDownloadFileModal] = useState(false);

  useEffect(() => {
    setTermsModalOpen(true);
  }, []);

  const closeModal = () => setTermsModalOpen(false);
  const closeDwnloadModal = () => setDownloadFileModal(false);

  const handleCancel = () => {
    setDownloadFileModal(true);
    setTermsModalOpen(false);
  };

  const handleDownloadTerms = async (e) => {
    e.preventDefault();
    const url = `${baseUrl}/download/nicdsign.pdf`;

    try {
      const response = await fetch(url, { method: "GET" });
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const blob = await response.blob();
      saveAs(blob, "NICDSign-TermsofUsage.pdf");
      setDownloadFileModal(false);
    } catch (error) {
      console.error("Error downloading file:", error);
    }
  };

  return (
    <div className="request-form-main App">
      <div className={isSubmitted ? "" : "wrapperInner"}>
        <div className="heard">
          <Header handleClose={handleClose} isSubmitted={isSubmitted} />
        </div>
        <RegistrationFormNew
          selectedFile={selectedFile}
          setSelectedFile={setSelectedFile}
          setIsSubmitted={setIsSubmitted}
          isSubmitted={isSubmitted}
        />
      </div>
      <div>
        <Modal
          isOpen={termsModalOpen}
          onRequestClose={closeModal}
          contentLabel="Terms Modal"
          className="custom-approve-modal-content"
        >
          <div className="termsWrapper">
            <span className="material-icons warningIcon"><img src={warningIcon} alt="warning" /></span>
            <h5>Important</h5>
          </div>
          <label className="termsLabel">
            Before proceeding further, download the Terms of Use (TOU) for
            NICDSign , and upload the signed copy of the same along with the
            request.
          </label>
          <div className="okbuttongroup ">
            <div>
              <button className="continueModal" onClick={handleCancel}>
                Continue
              </button>
            </div>
          </div>
        </Modal>
      </div>
      <div>
        <Modal
          isOpen={downloadFileModal}
          onRequestClose={closeDwnloadModal}
          contentLabel="Download Modal"
          className="custom-approve-modal-content"
        >
          <div className="termsWrapper">
            <span className="material-icons warningIcon"><img src={warningIcon} alt="warning" /></span>
            <h5>Important</h5>
          </div>
          <label className="termsLabel">
            Download the Terms of Use (TOU) for NICDSign from here
          </label>
          <div className="btnwrapper">
            <button className="cancelModal" onClick={closeDwnloadModal}>
              Cancel
            </button>
            <button
              className="continueModal flexAlign"
              onClick={handleDownloadTerms}
            >
              <span className="material-icons warningIcon"><img src={dwnloadWhite} alt="dwnloadWhite" /></span>
              <div>Download</div>
            </button>
          </div>
        </Modal>
      </div>
    </div>
  );
}

export default RequestFormMain;